import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import Snackbar1 from "../Snaclbar";

export default function NotificationForm({ type }) {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [error, setError] = useState({ state: false, text: "" });
  const [open, setOpen] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title || !body) {
      setError({
        state: true,
        text: "All fields need to be filled",
      });
      return;
    }
    if (title?.length > 255) {
      setError({
        state: true,
        text: "Title should be less than 255 Characters",
      });
      return;
    }
    let url = "";
    let id;
    let bodyJson={title,body};
    if (type === "sendNotiPro"){
      url = `${process.env.React_APP_BACKEND_URL}/api/admin/send-notification-to-professional`;
    }
    else if(type === "sendNotiClients"){
      url = `${process.env.React_APP_BACKEND_URL}/api/admin/send-notification-to-client`;}
    else {
     const what=type;
     const parts = what.split('-');
     id = parts[parts.length - 1]; 
    bodyJson={
        ...bodyJson,
        id
    }
    url = `${process.env.React_APP_BACKEND_URL}/api/admin/send-notification-app`;
}
    
    axios
      .post(
        `${url}`,
        bodyJson,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("admintoken")}`,
          },
        }
      )
      .then((res) => {
        setTitle("");
        setBody("");
        setOpen(true);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "75%",
        margin: "auto",
        p: 2,
      }}
      noValidate
      autoComplete="off"
    >
      <Typography
        component="h1"
        style={{
          margin: "auto",
          textAlign: "center",
          fontFamily: `${process.env.REACT_APP_FONT}`,
          fontWeight: "bold",
        }}
      >
        {type === "sendNotiPro"
          ? "Send Notification to Professionals":
          type === "sendNotiClients"?"Send Notification to Clients": "Send Notification to User"}
      </Typography>
      {open && <Snackbar1 mes={"Your notification was Sent"} />}
      <TextField
        label="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
      />

      <TextField
        label="Body"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        multiline
        rows={4}
        required
      />
      {error?.state && <p style={{ color: "red" }}>{error?.text}</p>}
      <Button type="submit" variant="contained">
        Submit
      </Button>
    </Box>
  );
}
